import { Component, Input, OnInit } from '@angular/core';
import { SecoesDeSplitter, Splitter, UnbalancedBox } from '../../state/network-parameters.model.generated';

@Component({
  selector: 'app-diagram',
  templateUrl: './diagram.component.html',
  styleUrls: ['./diagram.component.scss']
})
export class DiagramComponent implements OnInit {

  @Input()
  splitters: Splitter[] = [];

  @Input()
  internal: number;

  @Input()
  boxes: UnbalancedBox[] = [];

  readonly space = 100;

  constructor() { }

  ngOnInit(): void {
  }

}
